import createReducer from '../../../utils/createReducer';
import { fetchOverDataActionType } from '../actionTypes';

const initialState = {
  isFetchingOverviewData: false,
  OverviewDataFetchingError: false,
  overViewData: []
};
const reducer = {
  [fetchOverDataActionType.START_FETCHING_OVERVIEW_DATA]: state => {
    return {
      ...state,
      isFetchingOverviewData: true,
      OverviewDataFetchingError: false,
      overViewData: []
    };
  },
  [fetchOverDataActionType.SUCCESS_FETCHING_OVERVIEW_DATA]: (state, action) => {
    const data = action.payload;
    return {
      ...state,
      isFetchingOverviewData: false,
      OverviewDataFetchingError: false,
      overViewData: data
    };
  },

  [fetchOverDataActionType.FAILURE_FETCHING_OVERVIEW_DATA]: state => {
    return {
      ...state,
      isFetchingOverviewData: false,
      OverviewDataFetchingError: true
    };
  },
  [fetchOverDataActionType.CLEAR_OVERVIEW_DATA]: state => {
    return {
      ...state,
      isFetchingOverviewData: false,
      OverviewDataFetchingError: false,
      overViewData: []
    };
  }
};
export default createReducer(initialState, reducer);
